export const CFToastActionsSpacer = 'ACTIONS_SPACER';
